import React from 'react'

interface IPlayerVideoControls {
  isPlaying: boolean
  progress: number
  volume: number
  totalSeconds: number
  setIsPlaying: (isPlaying: boolean) => void
  setProgress: (progress: number) => void
  setVolume: (volume: number) => void
  setTotalSeconds: (totalSeconds: number) => void
}

interface InitialValues {
  isPlaying?: boolean
  progress?: number
  volume?: number
  totalSeconds?: number
}

export const usePlayerVideoControls = ({
  volume: initialVolume = 1,
  progress: initialProgress = 0,
  isPlaying: initialIsPlaying = false,
  totalSeconds: initialTotalSeconds = 0
}: InitialValues = {}): IPlayerVideoControls => {
  const [volume, setVolume] = React.useState<number>(initialVolume)
  const [progress, setProgress] = React.useState<number>(initialProgress)
  const [isPlaying, setIsPlaying] = React.useState<boolean>(initialIsPlaying)
  const [totalSeconds, setTotalSeconds] = React.useState<number>(initialTotalSeconds)

  return {
    volume,
    setVolume,
    progress,
    setProgress,
    isPlaying,
    setIsPlaying,
    totalSeconds,
    setTotalSeconds
  }
}
